import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Section, { SectionHeading } from '@/components/Section';
import Reveal from '@/components/Reveal';
import { SERVICES } from '@/data/services';
import { useQuote } from '@/components/QuoteDialog';

function CategoryCard({ category, index }) {
  const { openQuote } = useQuote();

  return (
    <Reveal delay={(index % 3) * 0.08} className="h-full">
      <article data-testid={`category-${category.id}`} className="group flex h-full flex-col bg-white">
        <div className="aspect-[4/3] overflow-hidden bg-sand">
          <img
            src={category.image}
            alt={category.alt}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-6 sm:p-7">
          <span className="eyebrow text-brand">{String(index + 1).padStart(2, '0')}</span>
          <h3 className="mt-3 text-xl sm:text-2xl leading-tight">
            <Link to={category.path} className="hover:text-brand transition-colors">
              {category.title}
            </Link>
          </h3>
          <p className="mt-3 text-ink/75 leading-relaxed">{category.description}</p>
          <ul className="mt-5 flex flex-wrap gap-x-2 gap-y-1 text-sm text-ink/70" aria-label="Primjeri">
            {category.examples.map((ex, i) => (
              <li key={ex}>
                {ex}
                {i < category.examples.length - 1 && <span aria-hidden="true">,</span>}
              </li>
            ))}
          </ul>
          <div className="mt-auto flex flex-wrap items-center gap-x-6 gap-y-2 pt-6">
          <Link
            to={category.path}
            data-testid={`category-more-${category.id}`}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-ink hover:text-brand transition-colors"
          >
            Saznajte više
          </Link>
          <button
            type="button"
            onClick={() => openQuote(category.id)}
            data-testid={`category-cta-${category.id}`}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-ink underline decoration-brand decoration-2 underline-offset-4 hover:text-brand transition-colors"
          >
            Zatražite ponudu
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </button>
          </div>
        </div>
      </article>
    </Reveal>
  );
}

export default function Categories() {
  return (
    <Section id="usluge" tone="paper">
      <SectionHeading
        eyebrow="Usluge"
        title="Šest područja, jedan partner."
        text="Od velikih formata na fasadama do tekstila i protokolarnih rješenja."
      />
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((category, i) => (
          <CategoryCard key={category.id} category={category} index={i} />
        ))}
      </div>
    </Section>
  );
}
